import React, { useCallback, useContext, useRef, memo } from "react";
import Drawer from "@material-ui/core/Drawer";

// context
import { StateContext, DispatchContext } from "bodycodi/cmap/app/components/common/context";

// component
import PickerHeader from "bodycodi/cmap/app/components/common/pickerHeader";

// utils
import { isEmpty } from "bodycodi/cmap/app/js/common";
import { api } from "bodycodi/cmap/app/js/api";

// assets
import memberEmpty from "bodycodi/cmap/app/img/icon_defailt.png";

// types
import { CommentUpdateDrawerProps, CommentUpdateInputProps } from "./types";

const CommentUpdateDrawer = ({
  selectedComment,
  refresh,
  closeConfirm,
}: CommentUpdateDrawerProps) => {
  const { dispatch } = useContext(DispatchContext);
  const { state } = useContext(StateContext);

  const handleClose = useCallback(() => {
    dispatch({ type: "POP_UP_OPEN", id: "COMMENT_UPD_POP", open: { commentUpdPop: false } });
  }, []);

  return (
    <Drawer
      anchor="bottom"
      open={state.commentUpdPop}
      onClose={handleClose}
      className="picker-pop auto"
    >
      <PickerHeader title="댓글 수정" onClose={handleClose} />
      <CommentUpdateInput
        selectedComment={selectedComment}
        refresh={refresh}
        handleClose={handleClose}
        closeConfirm={closeConfirm}
      />
    </Drawer>
  );
};

const CommentUpdateInput = ({
  selectedComment,
  refresh,
  handleClose,
  closeConfirm,
}: CommentUpdateInputProps) => {
  const textarea = useRef<HTMLTextAreaElement>(null);
  const { dispatch } = useContext(DispatchContext);

  const handleUpdate = () => {
    const text = textarea.current!.value;
    if (isEmpty(text)) {
      dispatch({
        type: "ALERT_SETTING",
        data: {
          alert: true,
          cancleYn: false,
          redYn: false,
          header: "댓글 수정",
          body: "댓글을 입력해 주세요",
          cancelAlert: () => {},
          closeAlert: () => {},
        },
      });
      return false;
    }
    api
      .post("/cmap4020/execCmntUpd", { cmntId: selectedComment.cmntId, cmntCtnt: text })
      .then(() => {
        refresh();
        handleClose();
        closeConfirm();
      });
  };

  return (
    <>
      <div className="comment-upd-pop">
        <div className="comment-upd-comment">
          <div className="profile">
            <img src={isEmpty(selectedComment.imgUrl) ? memberEmpty : selectedComment.imgUrl} />
          </div>
          <div className="comment-wrap">
            <div className="comment">
              <textarea ref={textarea} defaultValue={selectedComment.cmntCtnt} maxLength={100} />
            </div>
            <div className="btn-wrap">
              <div className="btn" onClick={handleClose}>
                취소
              </div>
              <div className="btn blue" onClick={handleUpdate}>
                수정완료
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CommentUpdateDrawer;
